const types = {
  SET_VOTING_GROUPS: "SET_VOTING_GROUPS",
  ADD_VOTING_GROUP: "ADD_VOTING_GROUP",
  DELETE_VOTING_GROUP: "DELETE_VOTING_GROUP",
  SET_VOTING_GROUP_UNITS: "SET_VOTING_GROUP_UNITS",
  SET_VOTING_DEPART_HIGHEST_SCORES: "SET_VOTING_DEPART_HIGHEST_SCORES",
  SET_VOTING_DEPART_GROUP_SCORES: "SET_VOTING_DEPART_GROUP_SCORES",

  SET_VOTE_RATINGS: "SET_VOTE_RATINGS",
  SET_VOTE_BEHAVIORS: "SET_VOTE_BEHAVIORS",
  SET_MY_VOTES: "SET_MY_VOTES",
  ADD_OR_UPDATE_HIGHEST_SCORE: "ADD_OR_UPDATE_HIGHEST_SCORE",
};

export default types;
